import React from "react";
import selectStyles from "./styles";
import styles from "./select.module.scss";
import { Form } from "react-bootstrap";

const DropdownIndicator = () => (
	<span className={styles.dropdownToggle} style={{ marginRight: 9 }} />
);

export const SelectBody = ({
	input,
	meta,
	onChangeCb,
	component: SelectComponent,
	...rest
}) => {
	const handleChange = option => {
		const value = option ? option.value : "";
		input.onChange(value);
		if (onChangeCb) onChangeCb(value, option);
	};

	// Blur must not carry a value: redux-form's BLUR reducer writes the payload
	// back into the field. react-select calls onChange and then blurs the input
	// synchronously when blurInputOnSelect is on (its default on touch devices,
	// so iOS Safari), which runs this handler before React re-renders. Passing
	// input.value would send the stale pre-selection value and wipe the freshly
	// selected option while marking the field touched.
	const handleBlur = () => {
		input.onBlur();
	};

	const { touched, error, warning } = meta;

	const hasError = touched && error;
	const errorMessage = hasError && (
		<Form.Control.Feedback type="invalid" className="d-block">
			{error}
		</Form.Control.Feedback>
	);

	const hasWarning = touched && warning;
	const warningMessage = hasWarning && (
		<Form.Control.Feedback type="invalid" className="d-block text-warning">
			{warning}
		</Form.Control.Feedback>
	);

	return (
		<Form.Group>
			<SelectComponent
				className="react-select-container"
				classNamePrefix="react-select"
				styles={selectStyles}
				components={{ DropdownIndicator }}
				onChange={handleChange}
				onBlur={handleBlur}
				hasError={hasError}
				hasWarning={hasWarning}
				{...rest}
			/>
			{errorMessage || warningMessage}
		</Form.Group>
	);
};
